var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1633.7 237.47",
    style: {
      enableBackground: "new 0 0 1633.7 237.47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M539.27,102.99c-0.08,0.17-0.27,0.28-0.45,0.24c-0.18-0.04-0.31-0.22-0.31-0.41l0.19-3.79l1.95,0.42 L539.27,102.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M553.94,55.32c-0.66,2.71-1.33,5.4-1.98,8.06c-0.66,2.65-1.32,5.27-2.02,7.79c-0.7,2.51-1.32,4.97-1.98,7.27 c-0.67,2.29-1.29,4.49-1.88,6.49c-1.18,4-2.22,7.35-2.99,9.66c-0.33,0.99-0.61,1.78-0.82,2.38l-4.05-0.87 c0.06-0.63,0.13-1.47,0.24-2.5c0.26-2.42,0.68-5.9,1.25-10.03c0.29-2.07,0.63-4.32,0.97-6.69c0.34-2.36,0.78-4.86,1.19-7.44 c0.4-2.58,0.88-5.24,1.37-7.93c0.5-2.69,1-5.42,1.51-8.16c0.62-3.06,1.21-6.11,1.79-9.1l9.5,2.05 C555.36,49.25,554.64,52.27,553.94,55.32"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M556.06,46.28l-9.5-2.05c0.24-1.2,0.47-2.38,0.71-3.55l9.61,2.07C556.6,43.92,556.33,45.09,556.06,46.28"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M556.12,10.26c0.42-0.97,1.39-1.63,2.51-1.61c1.51,0.01,2.72,1.23,2.7,2.74c0,0,0,0.28-0.03,0.83l-5.49-1.18 C556.01,10.52,556.12,10.26,556.12,10.26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M543.35,37.1c0.51,0.11,1.05-0.06,1.39-0.42c0.49-0.52,0.84-1.16,0.95-1.87l3.42-18.41 c0.38-2.02,1.92-3.56,3.93-3.95l2.36-0.44l0.93-0.18c0.49-0.09,0.95,0.22,1.04,0.71c0.09,0.48-0.22,0.96-0.71,1.04l-1.99,0.36 l-1.3,0.25c-1.28,0.25-2.27,1.23-2.51,2.52l-3.4,18.42c-0.21,1.03-0.7,2-1.43,2.77c-0.78,0.81-1.96,1.18-3.06,0.95 c-0.47-0.1-0.78-0.58-0.68-1.07C542.4,37.31,542.88,36.99,543.35,37.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M557.37,12.53c-0.09-0.49-0.55-0.8-1.04-0.71L555.41,12c0.16-0.38,0.29-0.72,0.4-0.97l5.49,1.18 c-0.01,0.66-0.06,1.69-0.16,3.04c-0.17,2.46-0.54,5.93-1.12,10.08c-0.33,2.05-0.6,4.31-1.05,6.65c-0.43,2.35-0.85,4.85-1.39,7.4 c-0.22,1.11-0.46,2.23-0.7,3.36l-9.61-2.07c0.24-1.14,0.49-2.26,0.74-3.36c0.57-2.54,1.21-4.99,1.78-7.31 c0.56-2.32,1.24-4.5,1.78-6.5c1.18-3.98,2.26-7.26,3.1-9.58l1.99-0.36C557.15,13.49,557.46,13.01,557.37,12.53"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M540.65,99.45L540.65,99.45l-1.95-0.42c-0.42-0.39-0.66-0.98-0.6-1.6c0,0,0.04-0.47,0.14-1.33l4.05,0.87 c-0.27,0.83-0.42,1.27-0.42,1.27C541.68,98.82,541.22,99.27,540.65,99.45"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M539.94,90.23c0.22-0.05,0.45,0.06,0.56,0.27l0.17,0.34c0.05,0.09,0.15,0.12,0.25,0.14l-15.09-80.31 l-1.52,0.29l15.2,80.87l0.04-1.12C539.55,90.48,539.71,90.28,539.94,90.23"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M543.41,90.63c0.1-0.04,0.2-0.12,0.22-0.23l0.17-0.86c0.03-0.14,0.15-0.25,0.29-0.27 c0.15-0.02,0.29,0.06,0.34,0.2l0.58,1.32l-15.2-80.87l-1.52,0.29L543.41,90.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M540.99,91.02c0.13-0.01,0.25-0.1,0.29-0.22l0.39-1.08c0.04-0.11,0.13-0.2,0.25-0.22 c0.12-0.02,0.24,0.02,0.32,0.11l0.81,0.94c0.08,0.1,0.21,0.14,0.34,0.1c0.01-0.01,0.01-0.02,0.01-0.02l-15.1-80.43l-2.48,0.46 l15.09,80.31C540.94,90.99,540.95,91.02,540.99,91.02"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M523.51,10.61c0.05,0.27,0.3,0.44,0.57,0.39l0.22-0.04l1.52-0.29l2.48-0.46l1.52-0.29l0.22-0.04 c0.27-0.05,0.44-0.3,0.39-0.57l-0.1-0.53l-6.91,1.3L523.51,10.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M528.9,3.86l-0.22,0.04l-5.52,1.04l-0.21,0.04c-0.27,0.05-0.44,0.31-0.39,0.57l0.1,0.53l6.91-1.3l-0.1-0.53 C529.42,3.98,529.17,3.81,528.9,3.86"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M528.2,1.3c-0.16-0.86-0.99-1.43-1.86-1.27l-2.4,0.45c-0.86,0.16-1.43,0.99-1.27,1.85l0.49,2.6l5.52-1.04 L528.2,1.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.98,
    y: 5.4,
    transform: "matrix(0.9828 -0.1848 0.1848 0.9828 7.6934 97.4118)",
    style: {},
    width: 7.03,
    height: 4.06
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M544.09,89.26c-0.15,0.02-0.27,0.12-0.29,0.27l-0.17,0.86c-0.02,0.11-0.11,0.19-0.22,0.23 c0,0-0.01,0.02-0.03,0.03c-0.13,0.03-0.26-0.01-0.34-0.1l-0.81-0.94c-0.08-0.09-0.2-0.13-0.32-0.11c-0.12,0.02-0.21,0.11-0.25,0.22 l-0.39,1.08c-0.05,0.13-0.16,0.21-0.29,0.22c-0.03,0-0.04-0.04-0.07-0.04c-0.1-0.02-0.2-0.05-0.25-0.14l-0.17-0.34 c-0.1-0.21-0.33-0.31-0.55-0.26c-0.22,0.05-0.39,0.24-0.4,0.47l-0.04,1.12l2.66,6.33l0.03-0.36c0.02-0.18,0.15-0.33,0.33-0.36 c0.18-0.04,0.35,0.04,0.44,0.2l0.25,0.45c0.08,0.15,0.24,0.23,0.41,0.21c0.16-0.02,0.3-0.14,0.35-0.3l0.18-0.66 c0.03-0.09,0.1-0.15,0.2-0.16c0.09-0.01,0.18,0.04,0.22,0.13l0.27,0.62l-0.11,4.16l0.29-11.29l-0.58-1.32 C544.38,89.33,544.24,89.25,544.09,89.26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M544.56,97.29c-0.04-0.09-0.12-0.14-0.22-0.13c-0.09,0.01-0.17,0.07-0.2,0.16l-0.18,0.66 c-0.04,0.16-0.18,0.28-0.35,0.3c-0.17,0.02-0.33-0.06-0.41-0.21l-0.25-0.45c-0.09-0.16-0.27-0.24-0.44-0.2 c-0.18,0.04-0.31,0.18-0.33,0.36l-0.03,0.36l1.71,4.08c0.09,0.22,0.3,0.34,0.5,0.3c0.2-0.04,0.35-0.23,0.36-0.46l0.11-4.16 L544.56,97.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M560.26,50.28c-0.24-1.27-1.35-2.19-2.64-2.19h-28.7c-1.29,0-2.4,0.92-2.64,2.19 c-3.29,17.64-4.95,33.62-4.95,45.34v8.09c0,3.18,2.58,5.75,5.76,5.75h32.36c3.18,0,5.76-2.58,5.76-5.75v-8.09 C565.21,83.9,563.55,67.92,560.26,50.28"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: -34.19,
    y: 61.22,
    width: 1707.16,
    height: 176.25
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#A8A1BF"
    },
    d: "M1134.65,701.44c-0.31,1.27-0.02,2.61,0.79,3.64 c0.81,1.03,2.04,1.63,3.35,1.63h33.98c1.9,0,3.57-1.26,4.09-3.08l162.31-564.86h-66.89L1134.65,701.44z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#9289AE"
    },
    points: "1132.57,132.17 1391.2,132.17 1406.28,195.96 1268.29,195.96  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#BEB8CF"
    },
    d: "M1378.15,138.77l145.32,564.32c0.53,2.11,2.41,3.62,4.6,3.62h32.96 c1.51,0,2.86-0.68,3.77-1.81c0.91-1.13,1.28-2.56,0.98-3.99l-120.73-562.14H1378.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#A8A1BF"
    },
    d: "M1378.15,138.77l145.32,564.32c0.53,2.11,2.41,3.62,4.6,3.62h16.59 l-146.83-567.94H1378.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#9289AE"
    },
    d: "M1134.65,701.44c-0.31,1.27-0.02,2.61,0.79,3.64 c0.81,1.03,2.04,1.63,3.35,1.63h14.86l138.31-567.94h-19.68L1134.65,701.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#A8A1BF"
    },
    d: "M17.96,701.44c-0.31,1.27-0.02,2.61,0.79,3.64 c0.81,1.03,2.04,1.63,3.35,1.63h33.98c1.9,0,3.57-1.26,4.09-3.08L222.4,138.77h-66.89L17.96,701.44z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#9289AE"
    },
    points: "176.55,132.17 1154.17,132.17 1320.06,195.96 161.47,195.96  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#BEB8CF"
    },
    d: "M444.95,706.71c1.29,0,2.5-0.58,3.31-1.58c0.81-1,1.12-2.31,0.85-3.57 L328.28,138.77h-47.21h-19.69l145.4,564.75c0.48,1.88,2.18,3.2,4.12,3.2h16.99H444.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#A8A1BF"
    },
    d: "M261.39,138.77l145.4,564.74c0.48,1.88,2.18,3.2,4.12,3.2h16.99 L281.08,138.77H261.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#9289AE"
    },
    d: "M17.96,701.44c-0.31,1.27-0.02,2.61,0.79,3.64 c0.81,1.03,2.04,1.63,3.35,1.63h14.86l138.31-567.94h-19.76L17.96,701.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#BEB8CF"
    },
    d: "M1631.42,108.9c4.24,0,7.67,1.92,7.67,4.28v21.67 c0,2.36-3.44,4.28-7.67,4.28H234.53c-4.24,0-7.67-1.92-7.67-4.28v-21.67c0-2.36,3.44-4.28,7.67-4.28H1631.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#A8A1BF"
    },
    d: "M240.05,108.9v30.23H4.28c-2.36,0-4.28-1.92-4.28-4.28v-21.67 c0-2.36,1.92-4.28,4.28-4.28H240.05z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.4633b79e.svg";
export { ForwardRef as ReactComponent };